import { render, staticRenderFns } from "./desktopCalendar.vue?vue&type=template&id=0224836e"
import script from "./desktopCalendar.vue?vue&type=script&lang=js"
export * from "./desktopCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports